import { render, staticRenderFns } from "./resourcemanage.vue?vue&type=template&id=54c618ae&scoped=true&"
import script from "./resourcemanage.vue?vue&type=script&lang=js&"
export * from "./resourcemanage.vue?vue&type=script&lang=js&"
import style0 from "./resourcemanage.vue?vue&type=style&index=0&id=54c618ae&lang=scss&scoped=true&"
import style1 from "./resourcemanage.vue?vue&type=style&index=1&id=54c618ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c618ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c618ae')) {
      api.createRecord('54c618ae', component.options)
    } else {
      api.reload('54c618ae', component.options)
    }
    module.hot.accept("./resourcemanage.vue?vue&type=template&id=54c618ae&scoped=true&", function () {
      api.rerender('54c618ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/resourcemanage.vue"
export default component.exports